<template>
  <div>
    <div class="p-3">
      <div class="row">
        <div class="col-12 col-md-6 pt-2">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" size='mini' v-model="userSearch"></el-input></span>
        </div>
        <div class="col-12 col-md-6">
          <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
        </div>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </div>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import statusViewer from './ag-grid/StatusViewer'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
  },
  data() {
    return {
      amReady: false,
      module: {
        ...module
      },
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      userSearch: null,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'file_name',
            width: 200,
            headerName: 'File Name',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          /*{
            field: 'used_for',
            width: 180,
            headerName: 'Usage',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },*/
          {
            field: 'used_for_name',
            width: 180,
            headerName: 'For',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          /*{
            field: 'division_name',
            width: 120,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },*/
          {
            field: 'size',
            width: 100,
            headerName: 'Size',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'records_counter',
            width: 150,
            headerName: 'Rates Count',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'records_uploaded',
            width: 150,
            headerName: 'Uploaded',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcodes_not_in_dialplan_count',
            width: 160,
            headerName: 'Not in Dialplan',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'status',
            width: 120,
            headerName: 'status',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(statusViewer),
          },
          {
            field: 'created_at',
            width: 150,
            headerName: 'from',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 120,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.navigateToPage(1)
  },
  methods: {
    downloadRateFile (params) {
      let url = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + '/storage/' + params.data.file_name
      window.open(url, '_blank');
    },
    ...$mapActions('voip-vendor-api', {getEntityList: 'getRatesDocumentList'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityList({page: page,rate_type:'voice'}).then(response => {
        this.agGrid.rowData = response.rows;
        this.recordsCounter = response.count;
        this.amReady = true
      })
      this.currentPage = page;
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})
      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.showPasswordField = false;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    deleteRateDocument(params) {
      this.$store.dispatch(this.module.info.name + '-api/deleteRateDocument', {id: params.data.id,rate_type:'voice'}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
